import type { Translations } from "../types";

const cs: Translations = {
  "meta.title": "Mapa kliknutí podle zemí",
  "meta.description":
    "Interaktivní mapa světa: bezplatná kliknutí za jednotlivé země a placená podpora přes Stripe, PayPal a Buy Me a Coffee.",

  "app.title": "Mapa kliknutí podle zemí",

  "map.intro":
    "Klikni na zemi na mapě a dej jí bezplatný hlas, nebo jí pošli finanční podporu - obojí se počítá do kombinovaného žebříčku níže. Mapa odráží pouze podporu v rámci této aplikace, nikoli skutečné národní bohatství nebo HDP.",
  "map.verifying": "Ověřuje se …",
  "map.confirmNotRobot": "Než budeš moct přidat bezplatná kliknutí, rychle potvrď, že nejsi robot:",
  "map.tryAgain": "Zkusit znovu",
  "map.registeringClick": "Zaznamenává se kliknutí …",
  "map.selectedCountry": "Vybraná země: {name}.",
  "map.selectFirstFeedback": "Země vybrána. Pro přidání bezplatného kliknutí nejprve níže potvrď, že nejsi robot.",
  "map.verificationExpired": "Ověření vypršelo - potvrď znovu, že nejsi robot.",
  "map.slowDown": "Trochu pomaleji - před dalším kliknutím chvíli počkej.",
  "map.clickFailed": "Kliknutí se nepodařilo zaznamenat. Zkus to prosím znovu.",
  "map.clickErrorGeneric": "Chyba při zaznamenávání kliknutí.",
  "map.leaderboardHeading": "Žebříček zemí",
  "map.emptySelection": "Vyber zemi na mapě, abys na ni mohl kliknout nebo ji podpořit.",
  "map.loadingData": "Načítání dat …",

  "worldmap.loadError": "Mapu se nepodařilo načíst.",
  "worldmap.resetZoom": "Obnovit přiblížení",
  "worldmap.resetButton": "⤾ Obnovit",
  "worldmap.loadingMap": "Načítání mapy …",
  "worldmap.unknownCountry": "Neznámá",
  "worldmap.ariaClicks": "{name}: {clicks} kliknutí",
  "worldmap.tooltipClicks": "{clicks} kliknutí",

  "legend.fewer": "Méně kliknutí",
  "legend.more": "Více kliknutí",

  "list.empty": "Zatím žádná kliknutí. Buď první!",
  "list.ariaLabel": "Žebříček zemí podle počtu kliknutí",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY není nastaven - konfiguraci najdeš v README.",
  "human.verificationFailedGeneric": "Ověření se nezdařilo.",
  "human.networkError":
    "Ověření se nepodařilo spojit (síťová chyba) - zkontroluj VITE_SUPABASE_URL, zda je verify-human nasazen, a ALLOWED_ORIGIN; viz README/NAVODILA.",
  "human.verificationFailedRetry": "Ověření se nezdařilo, zkus to znovu.",

  "provider.stripe": "💳 Karta (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Vybraná země",
  "panel.currentlyRanked": "Aktuálně na #{rank}. místě",
  "panel.shareCopied": "Zkopírováno ✓",
  "panel.shareShared": "Sdíleno ✓",
  "panel.shareButton": "🔗 Sdílet",

  "panel.tableClicks": "Kliknutí",
  "panel.tableFree": "Zdarma",
  "panel.tablePaid": "Placené",
  "panel.rowAllTime": "Celkem",
  "panel.rowThisYear": "Letos",
  "panel.rowThisWeek": "Tento týden",
  "panel.rowToday": "Dnes",

  "panel.totalCombined": "Celkem kombinovaně:",
  "panel.totalSupport": "Celková podpora:",

  "panel.paymentMethod": "Způsob platby",
  "panel.noPaymentMethod": "Momentálně není k dispozici žádný způsob platby.",
  "panel.supportAmount": "Částka podpory (EUR)",
  "panel.amountRange": "Částka by měla být mezi {min} a {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Odhadovaná placená kliknutí:",
  "panel.ratioInfo":
    "Poměr: {a} = {b} kliknutí (např. {c} = {d} kliknutí). Toto je pouze odhad před platbou - konečný počet kliknutí vždy vypočítá a potvrdí server na základě skutečně potvrzené platby.",
  "panel.preparing": "Připravuje se …",
  "panel.continueWith": "Pokračovat s {provider}",
  "panel.choosePaymentMethod": "Vyber způsob platby",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME není nastaven - konfiguraci najdeš v README.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID není nastaven - konfiguraci najdeš v README.",

  "panel.paypalAmountInfo": "Částka: {amount} (odhadem {clicks} kliknutí). Dokonči platbu pomocí tlačítka PayPal níže.",
  "panel.back": "← Zpět",

  "panel.bmcWarningTitle": "⚠️ Než přejdeš na BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Vlož níže uvedený kód do pole zprávy/poznámky při placení — jinak nebudeme vědět, kterou zemi podporuješ. Bez kódu nemůžeme platbu přiřadit žádné zemi.",
  "panel.copy": "Kopírovat",
  "panel.copied": "Zkopírováno ✓",
  "panel.suggestedAmount": "Navrhovaná částka:",
  "panel.bmcAmountNote":
    "(odhadem {clicks} kliknutí). BuyMeCoffee bohužel nepodporuje přenesení částky přes odkaz — zadej/vyber si ji sám na jejich webu. Skutečný počet kliknutí se vždy počítá z částky, kterou na BuyMeCoffee opravdu pošleš, ne z tohoto odhadu.",
  "panel.openBmc": "Otevřít BuyMeCoffee a pokračovat →",
  "panel.waitingProvider": "Čeká se na potvrzení platby od poskytovatele platby …",
  "panel.waitingConfirmation": "Čeká se na potvrzení platby …",
  "panel.timedOut":
    "Kontrole vypršel časový limit. Pokud jsi platbu dokončil, mapa se aktualizuje, jakmile server obdrží potvrzení - to může někdy trvat trochu déle.",
  "panel.checkAgain": "Zkontrolovat znovu",

  "panel.cancelled": "Platba byla zrušena nebo se nezdařila. Mapa se nezměnila.",
  "panel.tryAgain": "Zkusit znovu",

  "panel.confirmed": "✅ Podpora potvrzena!",
  "panel.confirmedBody": "{country} obdržela {clicks} placených kliknutí za {amount}.",

  "panel.errorPreparingSupport": "Chyba při přípravě tvé podpory.",
  "panel.errorPreparingPayment": "Chyba při přípravě platby.",
  "panel.errorConfirmingPayment": "Chyba při potvrzování platby.",
  "panel.errorPayingPaypal": "Chyba při platbě přes PayPal.",

  "share.unranked": "{flag}{country} potřebuje tvou podporu na mapě světa!\nPomoz jí postoupit v žebříčku 👇",
  "share.rank1": "{flag}{country} je aktuálně na #1. místě!\nPomoz nám udržet se na vrcholu 👇",
  "share.rankN": "{flag}{country} je aktuálně na #{rank}. místě!\nPomoz nám dostat se na #1 👇",

  "language.switcherLabel": "Jazyk",
};

export default cs;
